import { type SVGAttributes, type JSX } from 'react'

type LogoColor = 'light' | 'dark' | 'inverted' | 'default'
type LogoProps = SVGAttributes<HTMLImageElement> & { color?: LogoColor; darkInverted?: boolean }

function LogoSVG(props: LogoProps): JSX.Element {
    const { ...otherProps } = props

    return (
        <img src="/logo_d.png" alt="Logo" {...otherProps} />
    )
}

function CompanySVG(props: LogoProps): JSX.Element {
    const { ...otherProps } = props

    return (
        <img src="/ready_d.png" alt="Logo" {...otherProps} />
    )
}

function ApplicationSVG(props: LogoProps): JSX.Element {
    const { ...otherProps } = props

    return (
        <img src="/smart_d.png" alt="Logo" {...otherProps} />
    )
}

export { ApplicationSVG, LogoSVG, CompanySVG }
